import React from "react";
import styled from "styled-components";
import { theme } from "styles/theme";

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

const Title = styled.h1`
  margin: 0;
  font-size: ${theme.fontSizes.large};
  color: ${theme.colors.textPrimary};
  font-weight: ${theme.fontWeights.bold};
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-left: auto;
`;

interface PageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

export function AppPageHeader({ title, children }: PageHeaderProps) {
  return (
    <Header>
      <Title>{title}</Title>
      {children ? <HeaderActions>{children}</HeaderActions> : null}
    </Header>
  );
}
